import { itemHasContent } from '../../utils/helpers';

const CS_FIELDS = [
  'name',
  'description',
  'frustrates',
  'goals',
  'problems',
  'type',
];

export default function calculateCSProgress(rootState, minRequired = 1) {
  let filledCount = 0;
  let totalCollectionItems = 0;

  if (rootState.customerSegment.collection.length) {
    rootState.customerSegment.collection.forEach((item) => {
      let foundUnfilledField = false;
      CS_FIELDS.forEach((field) => {
        if (!itemHasContent(item, [field])) {
          foundUnfilledField = true;
        }
      });
      if (!foundUnfilledField) filledCount += 1;
    });
  }
  totalCollectionItems += rootState.customerSegment.collection.length;

  if (filledCount === 0) return 0;
  const denominator = Math.max(minRequired, totalCollectionItems);
  const sectionProgress = Math.round((filledCount / denominator) * 100);
  return sectionProgress;
}
